import { useEffect,  useState } from '../../common/common';
import axiosJWT from '../../secureAPI/axiosJWT.js';
import { showToast } from '../../Utils/toastUtils';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import { useErrorContext } from '../../context/ErrorContext';
import { validateEditBadge } from '../../validation/Authentication/Validation.js';
import useGetUserData from '../../secureAPI/GetUserData';
import Navigations from '../../common/useNavigation';

const MidBadges = (type) => {
    const { navigateDashboard } = Navigations();
    const { users,userPlan,Remainuser,subUser } = useGetUserData();
    const [isLoading, setisLoading] = useState(false);
    const { setValidationError, clearAllErrors } = useErrorContext();
    const [badges, setBadges] = useState([]);
    const [badgeEditID, setEditBadgeID] = useState();
    const [badgedelteID, setDeleteBadgeID] = useState();
    const [showAddModal, setShowAddModal] = useState(false);
    const handleCloseAddModal = () => setShowAddModal(false);
    const handleShowAddModal = () => setShowAddModal(true);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
  
    const handleShowEditModal = (id) => {
        setEditBadgeID(id);
        // Find the badge with the matching id
        const selectedBadge = badges.find(item => item.id === id);

        if (selectedBadge) {
            // Set the state with the selected badge's data
            setBadgesDetails({
                title: selectedBadge.name,
                bgcolor: selectedBadge.bgcolor,
                textcolor: selectedBadge.textcolor,
            });

            // Show the modal
            setShowEditModal(true);
        } else {
            // alert('Badge not found!');
        }
    };

    // Handle modal close
    const handleCloseEditModal = () => {
        setShowEditModal(false);
    };
    const handleCloseDeleteModal = () => setShowDeleteModal(false);
    const handleShowDeleteModal = (id) => { 
        setDeleteBadgeID(id)
        setShowDeleteModal(true)
    };
    const [badgesDetails,setBadgesDetails] = useState({
        title:'',
        bgcolor:'#000',
        textcolor:'#000',
    })
    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setBadgesDetails((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
        // console.log({ values: badgesDetails });
        if (Object.keys(validateAndSetErrors(badgesDetails)).length === 0) clearAllErrors();
    };
    
    // Reusable function to handle validation and set errors
    const validateAndSetErrors = (values) => {
        const validationErrors = validateEditBadge(values);
        Object.keys(validationErrors).forEach(field => setValidationError(field, validationErrors[field]));
        return validationErrors;
    };
    const logUserData = () => {
        // console.log({ users: users });
        if (users?.length > 0) {
            const userTypes = users[0]['UserType'];
            const usertypeArray = typeof userTypes === 'string' ? userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];
            // console.log({usertypeArray:usertypeArray});
    
            const hasOne = usertypeArray.includes(1);
            const hasTwo = usertypeArray.includes(2);

            if (type === 'seller' && users[0]['IsPersonalDetils'] === 1  && (hasOne && hasTwo )) {
            }
            else {
                navigateDashboard('buyer');
            }
        }
    };
    // useEffect(() => {
    //     //  console.log('called useeffectsss');
    //     if (Array.isArray(users) && users.length > 0) {
    //         console.log('useEffect called, users:', users);
    //         logUserData();
    //     }
    // }, [users]);
    // const logUserData = () => {
    //     console.log({ users: users });
    //     if (users?.length > 0) {
    //         const userTypes = users[0]['UserType'];
    //         const usertypeArray = typeof userTypes === 'string' ? userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];
    
    //         const hasOne = usertypeArray.includes(1);
    //         const hasTwo = usertypeArray.includes(2);
    //         if (type === 'seller' && users[0]['IsPersonalDetils'] === 1 && (hasOne && hasTwo)) {
    //         }
    //         else{
    //             navigateDashboard('buyer');
    //         }
    //     }
    // };
    useEffect(() => {
        getProductsBadges();
    }, []);

    const getProductsBadges = async () => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetProductBadges`, {app:0}, { withCredentials: true })
                .then((res) => {
                    StopLoading(setisLoading);
                    if (res.data.success === 1) {
                        setBadges(res.data.data);
                    }
                    else {
                        StopLoading(setisLoading)
                        showToast(res.data.message, 'error');
                    }
                })
                .catch((err) => {
                    StopLoading(setisLoading)
                    showToast('Something went wrong ! please try again ', 'error');
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to get suplliers, please try again later ", 'error');
        }
    }

    const handlesubmit = async () => {
        const title = badgesDetails.title;
        const backgroundcolor = badgesDetails.bgcolor;
        const textcolor = badgesDetails.textcolor;
        
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/AddBadges`,{title,backgroundcolor,textcolor} , { withCredentials: true })
                .then((response) => {
                    // console.log(response.data);
                    StopLoading(setisLoading);
                    if (response.data.success === 1) {
                        // console.log(response.data.Badges);
                        setBadges(response.data.Badges);
                        // getCategories(0);
                        StopLoading(setisLoading)
                        showToast(response.data.message, 'success');
                        // values.subCategoryName = "";
                        handleCloseAddModal();
                    }
                    else {
                        StopLoading(setisLoading)
                        showToast(response.data.message, 'error');
                    }
                })
                .catch((err) => {
                    const res_status = err.response.data.success;
                    const res_message = err.response.data.message;
                    if (res_status !== "" && res_message !== "") { }
                    else if (err.status === 401) {
                        // logout();
                    }
                    else {
                        showToast(err.data.message, 'error');
                    }
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to Add Badges, please try again later ", 'error');
        }
    };

    const handleSaveChanges = async () => {
        // alert(badgeEditID);
        const title = badgesDetails.title;
        const backgroundcolor = badgesDetails.bgcolor;
        const textcolor = badgesDetails.textcolor;
        
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/EditBadges`,{badgeEditID,title,backgroundcolor,textcolor} , { withCredentials: true })
                .then((response) => {
                    // console.log(response.data);
                    StopLoading(setisLoading);
                    if (response.data.success === 1) {
                        // console.log(response.data);
                        setBadges(response.data.Badges);
                        StopLoading(setisLoading)
                        showToast(response.data.message, 'success');
                        // values.subCategoryName = "";
                        handleCloseEditModal();
                    }
                    else {
                        StopLoading(setisLoading)
                        showToast(response.data.message, 'error');
                    }
                })
                .catch((err) => {
                    const res_status = err.response.data.success;
                    const res_message = err.response.data.message;
                    if (res_status !== "" && res_message !== "") { }
                    else if (err.status === 401) {
                        // logout();
                    }
                    else {
                        showToast(err.data.message, 'error');
                    }
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to Update Badges, please try again later ", 'error');
        }
    };

    const handleDelete = async () => {
        // Logic to delete the badge (e.g., update state or make an API call)
        // console.log("Badge deleted");
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/DeleteBadges`,{badgedelteID} , { withCredentials: true })
                .then((response) => {
                    // console.log(response.data);
                    StopLoading(setisLoading);
                    if (response.data.success === 1) {
                        // console.log(response.data);
                        setBadges([]);
                        StopLoading(setisLoading);
                        getProductsBadges();
                        showToast(response.data.message, 'success');
                        // values.subCategoryName = "";
                        handleCloseDeleteModal();
                    }
                    else {
                        StopLoading(setisLoading)
                        showToast(response.data.message, 'error');
                    }
                })
                .catch((err) => {
                    const res_status = err.response.data.success;
                    const res_message = err.response.data.message;
                    if (res_status !== "" && res_message !== "") { }
                    else if (err.status === 401) {
                        // logout();
                    }
                    else {
                        showToast(err.data.message, 'error');
                    }
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to Delete Badges, please try again later ", 'error');
        }
        
    };

  return {users,userPlan,Remainuser,subUser,isLoading,badges,showEditModal,setShowEditModal,showDeleteModal,setShowDeleteModal,
    handleCloseEditModal,handleShowEditModal,handleCloseDeleteModal,handleShowDeleteModal,badgesDetails,setBadgesDetails,handleChange,handleDelete,handleSaveChanges,showAddModal,setShowAddModal,handleCloseAddModal,handleShowAddModal,handlesubmit}
}

export default MidBadges